var e = {};
export { e as h };